<template>
  <LoginView/>
  <section id="client" v-if="global.authenticated && (global.account.clientMode>0)">
    <div class="overlay">
      <div class="container">
        <div class="d-flex align-items-start flex-column justify-content-center">
          <table className="main-setings">
            <tr>
              <td className="cell">Имя:</td>
              <td className="cell"><input type="text" v-model="client.name"/></td>
            </tr>
            <tr>
              <td className="cell">Телефон:</td>
              <td className="cell"><input type="text" v-model="client.phone"/></td>
            </tr>
            <tr>
              <td className="cell">Email:</td>
              <td className="cell"><input type="text" v-model="client.email"/></td>
            </tr>
            <tr>
              <td className="cell"></td>
              <td className="cell">
                <input className="btn btn-sm main-btn text-uppercase" :disabled="loading" @click="addClient()"
                value="Добавить">
              </td>
            </tr>
          </table>
          <table v-if="global.account.clientMode==3" className="main-setings">
            <tr>
              <td className="cell">Дата начала:</td>
              <td className="cell"><input type="date" v-model="generateScheduleDate"/></td>
            </tr>
            <tr>
              <td className="cell">Дата конца:</td>
              <td className="cell"><input type="date" v-model="generateScheduleEndDate"/></td>
            </tr>
            <tr>
              <td className="cell"></td>
              <td className="cell">
                <input className="btn btn-sm main-btn text-uppercase" :disabled="loading" @click="generateSchedule()"
                value="Заполнить по расписанию">
              </td>
            </tr>
          </table>
          <table className="main-setings">
            <tbody>
            <tr>
              <td className="cell">Имя</td>
              <td className="cell">Телефон</td>
              <td className="cell">Email</td>
              <!--td class="cell">Дата регистрации</td-->
              <td></td>
              <td v-if="global.account.clientMode==3"></td>
            </tr>
            </tbody>
            <tbody v-for="(p,index) in clients"
            :key="index">
            <tr>
              <td className="cell">{{p.name}}</td>
              <td className="cell">{{p.phone}}</td>
              <td className="cell">{{p.email}}</td>
              <!--td class="cell">{{getDate(p.createdDt)}}</td-->
              <td className="cell">
                <input className="btn btn-sm main-btn text-uppercase" :disabled="loading" @click="getClientUri(p)"
                value="Получить ссылку">
              </td>
              <td className="cell">
                <input className="btn btn-sm main-btn text-uppercase" :disabled="loading"
                @click="p.showActionModal=true" value="Удалить клиента">
              </td>
              <td className="cell" v-if="global.account.clientMode==3">
                <input className="btn btn-sm main-btn text-uppercase" :disabled="loading"
                @click="p.showSchedule=!p.showSchedule"
                value="Расписание">
              </td>
              <ModalDialog
              :title="'Ссылка для клиента'"
              :message=p.uri
              :isVisible=p.showModal
              @close="p.showModal = false"
              />
              <ModalActionDialog
              :title="'Удаление клиента'"
              :message="'Вы действительно хотите удалить клиента: '+p.name"
              :isVisible=p.showActionModal
              @action="deleteClient(p)"
              @close="p.showActionModal = false"
              />
            </tr>
            <tr v-if="p.showSchedule">
              <td className="cell" colspan=5>
              <table>
                <tr>
                  <td className="cell">Объект</td>
                  <td className="cell">День</td>
                  <td className="cell">Час</td>
                  <td className="cell">Минута</td>
                  <td className="cell">Длительность(минут)</td>
                  <td className="cell">
                  </td>
                </tr>
                <tr v-for="(s,index2) in p.schedules.filter(ss => ss.deleted == false)"
                :key="index2">
                <td className="cell">
                  <select v-model="s.subjectId">
                    <option v-for="subject in subjects"
                    :key="subject.id" :value="subject.id">
                    {{subject.name}}
                  </option>
                </select>
            </td>
            <td className="cell">
              <select v-model="s.day" required>
                <option value="2">Понедельник</option>
                <option value="3">Вторник</option>
                <option value="4">Среда</option>
                <option value="5">Четверг</option>
                <option value="6">Пятница</option>
                <option value="7">Суббота</option>
                <option value="1">Воскресенье</option>
              </select>
            </td>
            <td className="cell"><input type="number" v-model="s.hour" min="0" required/></td>
            <td className="cell"><input type="number" v-model="s.minute" min="0" required/></td>
            <td className="cell"><input type="number" v-model="s.duration" min="0" required/></td>
            <td className="cell">
              <input :disabled="loading" @click="s.deleted=true" type="button"
              class="btn btn-sm btn-danger text-uppercase"
              value="Удалить">
            </td>
          </tr>
          <tr>
            <td className="cell" colSpan="4"></td>
            <td className="cell"><input :disabled="loading"
              className="btn btn-sm main-btn text-uppercase"
              @click="p.schedules.push({subjectId:subjects[0].id,clientId:p.id,day:2,hour:12,minute:0,duration:60,deleted:false})"
              value="Добавить">
            </td>
            <td className="cell">
              <input :disabled="loading" @click="setSchedule(p.schedules)" type="button"
              class="btn btn-sm btn-success main-btn text-uppercase"
              value="Сохранить">
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </tbody>
</table>
</div>
</div>
</div>
</section>
</template>

<style>
  #client .overlay{
  background: none;
}
  #client table{
  background: #fff;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.12);
}
  #client .main-setings{
  margin-top: 30px;
}
  #client .cell{
  height: 52px;
  padding: 1px 16px;
  text-align: left;
}
  #client .modal-dialog{
  width: 400px;
}
  #client .modal-dialog .btn-primary{
  width: 100%;
}
  #client .modal-dialog input{
  width: 100%;
}
  #client .btn-sm{
    border-radius: 100px;
  min-width: 150px;
}

</style>

<script>
  import axios from 'axios'
  import Toast from '@/js/toast.min.js'
  import LoginView from '@/views/LoginView.vue'
  import {global} from "@/global.js";
  import ModalDialog from '@/components/ModalDialog.vue';
  import ModalActionDialog from '@/components/ModalActionDialog.vue';

export default {
  name: 'LkClientView',
    client:{name:"",phone:""},
  components: {
    LoginView,
    ModalDialog,
    ModalActionDialog
  },
  data() {
    return {
      global: global,
  subjects:[],
  loading:false,
      account:{subjects:[]},
      clients:[],
      client: {name: "", phone: "", email: ""},
      generateScheduleDate: null,
      generateScheduleEndDate: null
    }
  },

  mounted() {
    global.value.lk=true;
    if(global.value.authenticated) {
      this.load();
    }else {
      setTimeout(function () {
        if (global.value.authenticated) {
          this.load();
        }
      }.bind(this), 1000);
    }
  },


  methods: {
    load(){
      this.getAccount();
      this.getClients();
      this.getSubjects();
    },
    getAccount(){
      axios.get(global.value.url + "lk/account").then(response => {
        this.account = response.data;
      });
    },
    getClients(){
      axios
          .get(global.value.url + "lk/client")
          .then(response => {
            this.clients=response.data;
          })
          .finally(() => (this.loading = false));
    },
    getSubjects(){
      axios
        .get(global.value.url + "lk/subject")
        .then(response => {
        this.subjects=response.data;
      });
    },

    getClientUri(p){
        axios
        .get(global.value.url + "lk/client/uri?clientId="+p.id)
        .then(response => {
          if(response.data.success){
            navigator.clipboard.writeText(response.data.text);
            p.uri = response.data.text;
            p.showModal = true;
          }else{
            new Toast({
              title: false,
              text: response.data.text,
              theme: 'danger',autohide: true,interval: 10000
            });
          }
      });
    },

  setSchedule(schedules){
    this.loading = true;
    this.accountErorr = "";
    axios
    .post(global.value.url + "lk/schedule", schedules)
    .then(response => {
      if(response.data.success){

        this.getClients();
      }else{
        new Toast({
          title: false,
          text: response.data.text,
          theme: 'danger',autohide: true,interval: 10000
        });
      }
        this.errored = false;
    })
    .catch(() => {
      this.accountErorr="Ошибка сохранения";
      this.errored = true;
      this.loading = false;
    });
  },

  generateSchedule(){
    this.loading = true;
    this.accountErorr = "";
    axios.post(global.value.url + "lk/generate-schedule?date="+this.generateScheduleDate+"&endDate="+this.generateScheduleEndDate)
      .then(response => {
        if(response.data.success){
          new Toast({
            title: false,
            text: response.data.text,
            theme: 'success',autohide: true,interval: 10000
          });
        }else{
          new Toast({
            title: false,
            text: response.data.text,
            theme: 'danger',autohide: true,interval: 10000
          });
        }
        this.errored = false;
      })
      .catch(() => {
        this.accountErorr="Ошибка сохранения";
        this.errored = true;
      })
      .finally(() => (this.loading = false));
},

  deleteClient(p){
    this.loading = true;
      axios
      .delete(global.value.url + "lk/client/"+p.id)
      .then(response => {
          if(response.data.success){
            this.getClients();
        }else{
          new Toast({
            title: false,
            text: response.data.text,
            theme: 'danger',autohide: true,interval: 10000
          });
        }
    })
    .finally(() => (this.loading = false));
  },
    getDate(d){
      var date = new Date(d);
      return ('0' + (date.getDate())).slice(-2)+'.'+('0' + (date.getMonth() + 1)).slice(-2)+'.'+date.getFullYear()+' '+('0' + date.getHours()).slice(-2)+':'+('0' + date.getMinutes()).slice(-2)+':'+('0' + date.getSeconds()).slice(-2);
    },
    addClient(){
      this.loading = true;
      this.accountErorr = "";
      axios
          .post(global.value.url + "lk/client", this.client)
          .then(response => {
            if(response.data.success){
              navigator.clipboard.writeText(response.data.text);
              this.getClients();
            }else{
              new Toast({
                title: false,
                text: response.data.text,
                theme: 'danger',autohide: true,interval: 10000
              });
            }
            this.errored = false;
          })
          .catch(() => {
            this.accountErorr="Ошибка сохранения";
            this.errored = true;
          })
          .finally(() => (this.loading = false));
    }
  }
}
</script>
